import { render, staticRenderFns } from "./UserEmailInput.vue?vue&type=template&id=bea2884c&scoped=true&"
import script from "./UserEmailInput.vue?vue&type=script&lang=ts&"
export * from "./UserEmailInput.vue?vue&type=script&lang=ts&"
import style0 from "./UserEmailInput.vue?vue&type=style&index=0&id=bea2884c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea2884c",
  null
  
)

export default component.exports